/* CLEO — Página 2 · Mentora + Comités — cleo-mentora-comites.js
   = script.js del ZIP (reveal · hero stagger · calculadora · FAQ · tabs · deep-link · smooth scroll)
   + buscador de ciudad CLEO (cleoInitCity, mismo de producción)
   + envío BLINDADO de los 2 forms reales (timeout + reintento x2 + backup local + rescate WhatsApp)
   ─────────────────────────────────────────────────────────────
   ⚠️ Los 2 forms son los REALES de /pages/cleo. Webhooks y names NO se tocan.
   Mentora → hook vcik31w6...  ·  Comité → hook i1tezgkk...
*/
(function () {
  'use strict';

  var WA_NUM = '595984444305';

  /* ---------- Helpers ---------- */
  var fmtGs = function (n) { return 'Gs ' + Math.round(n).toLocaleString('es-PY').replace(/,/g, '.'); };

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    document.querySelectorAll('.reveal, .reveal-stagger').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal, .reveal-stagger').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Hero letras stagger ---------- */
  document.querySelectorAll('.hero-letters').forEach(function (wrap) {
    var text = wrap.textContent;
    wrap.textContent = '';
    [].forEach.call(text, function (ch, i) {
      var s = document.createElement('span');
      s.textContent = ch === ' ' ? ' ' : ch;
      s.style.animationDelay = (0.04 * i) + 's';
      wrap.appendChild(s);
    });
  });

  /* ---------- Calculadora Mentora (fórmulas validadas) ---------- */
  var calc = document.getElementById('cleo-calc-mentora');
  if (calc) {
    var i1 = document.getElementById('calc-num-emp');
    var i2 = document.getElementById('calc-compra-emp');
    var i3 = document.getElementById('calc-compras-prop');
    var vBono = document.getElementById('calc-out-bono');
    var vPropia = document.getElementById('calc-out-propia');
    var vMensual = document.getElementById('calc-out-mensual');
    var vTotal = document.getElementById('calc-out-total');
    var totalBox = document.querySelector('.cleo-calc__total');

    var update = function () {
      var numEmp = parseInt(i1.value) || 0;
      var compraPorEmp = parseInt(i2.value) || 0;
      var comprasPropias = parseInt(i3.value) || 0;
      var comprasEquipo = numEmp * compraPorEmp;
      var bonoEquipo = Math.round(comprasEquipo * 0.08);
      var ventasPropias = Math.round(comprasPropias / 0.6993);
      var gananciaPropia = ventasPropias - comprasPropias;
      var bonoMensualPropio = Math.round(comprasPropias * 0.10);
      var total = bonoEquipo + gananciaPropia + bonoMensualPropio;
      vBono.textContent = '+' + fmtGs(bonoEquipo);
      vPropia.textContent = '+' + fmtGs(gananciaPropia);
      vMensual.textContent = '+' + fmtGs(bonoMensualPropio);
      vTotal.textContent = fmtGs(total);
      totalBox.classList.remove('is-updated');
      void totalBox.offsetWidth;
      totalBox.classList.add('is-updated');
    };
    [i1, i2, i3].forEach(function (inp) {
      inp.addEventListener('input', update);
      inp.addEventListener('change', update);
    });
    update();
  }

  /* ---------- FAQ accordion (exclusivo) ---------- */
  document.querySelectorAll('.cleo-faq').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.open) {
        document.querySelectorAll('.cleo-faq[open]').forEach(function (other) {
          if (other !== d) other.open = false;
        });
      }
    });
  });

  /* ---------- Tabs Mentora / Comité — 2 botones grandes que despliegan ----------
     El formulario NO se muestra por defecto: aparece SOLO al tocar su botón.
     Tocar el botón ya activo lo cierra de nuevo. */
  var tabsWrap = document.querySelector('.cleo-tabs');
  if (tabsWrap) {
    var btns = tabsWrap.querySelectorAll('.cleo-tabs__btn');
    var panels = tabsWrap.querySelectorAll('.cleo-tabs__panel');
    function closeAll() {
      btns.forEach(function (x) { x.classList.remove('is-active'); });
      panels.forEach(function (p) { p.classList.remove('is-active'); });
      tabsWrap.classList.remove('is-comite');
    }
    function openTab(tab) {
      closeAll();
      btns.forEach(function (x) { if (x.dataset.tab === tab) x.classList.add('is-active'); });
      panels.forEach(function (p) { if (p.dataset.tab === tab) p.classList.add('is-active'); });
      tabsWrap.classList.toggle('is-comite', tab === 'comite');
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.classList.contains('is-active')) { closeAll(); }
        else { openTab(b.dataset.tab); }
      });
    });
    // El formulario arranca SIEMPRE cerrado. Solo se abre tocando uno
    // de los 2 botones grandes. Los CTAs de la página solo hacen scroll
    // hasta acá (ver smooth scroll), no despliegan nada.
    closeAll();
  }

  /* ---------- Buscador de ciudad CLEO (factory, mismo de producción) ---------- */
  function cleoInitCity(prefix) {
    var input = document.getElementById(prefix + '-city-input');
    var dd = document.getElementById(prefix + '-city-dd');
    var search = document.getElementById(prefix + '-city-search');
    var list = document.getElementById(prefix + '-city-list');
    var hidden = document.getElementById(prefix + '-city-val');
    if (!input || !dd || !list || !hidden) return;
    input.addEventListener('click', function (e) {
      e.stopPropagation();
      dd.classList.toggle('is-open');
      if (dd.classList.contains('is-open') && search) search.focus();
    });
    document.addEventListener('click', function (e) {
      if (!dd.contains(e.target) && e.target !== input) dd.classList.remove('is-open');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') dd.classList.remove('is-open');
    });
    if (search) search.addEventListener('input', function () {
      var q = this.value.trim().toLowerCase();
      list.querySelectorAll('li').forEach(function (li) {
        li.hidden = li.textContent.toLowerCase().indexOf(q) < 0;
      });
    });
    list.querySelectorAll('li').forEach(function (li) {
      li.addEventListener('click', function () {
        input.value = this.dataset.val;
        hidden.value = this.dataset.val;
        input.style.color = 'var(--cleo-negro)';
        dd.classList.remove('is-open');
        if (search) search.value = '';
        list.querySelectorAll('li').forEach(function (x) { x.hidden = false; });
      });
    });
  }
  cleoInitCity('cleo-mentora');
  cleoInitCity('cleo-comite');

  /* ---------- Envío BLINDADO (timeout + reintento + backup + rescate WA) ---------- */
  function fetchWithTimeout(url, opts, ms) {
    return new Promise(function (resolve, reject) {
      var ctrl = new AbortController();
      var to = setTimeout(function () { ctrl.abort(); reject(new Error('timeout')); }, ms);
      fetch(url, Object.assign({}, opts, { signal: ctrl.signal }))
        .then(function (r) { clearTimeout(to); if (!r.ok) reject(new Error('http_' + r.status)); else resolve(r); })
        .catch(function (e) { clearTimeout(to); reject(e); });
    });
  }
  function submitWithRetry(url, payload, n) {
    var opts = { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) };
    return fetchWithTimeout(url, opts, 12000).catch(function (err) {
      if (n > 0) return new Promise(function (r) { setTimeout(r, 1500); }).then(function () { return submitWithRetry(url, payload, n - 1); });
      throw err;
    });
  }
  function bindBlindajeForm(cfg) {
    var form = document.getElementById(cfg.formId);
    if (!form) return;
    var backupKey = cfg.backupKey;
    function saveBackup(p) {
      try {
        var arr = JSON.parse(localStorage.getItem(backupKey) || '[]');
        arr.push({ ts: Date.now(), payload: p });
        localStorage.setItem(backupKey, JSON.stringify(arr.slice(-10)));
      } catch (e) {}
    }
    function clearBackup() { try { localStorage.removeItem(backupKey); } catch (e) {} }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      // honeypot
      var hp = form.querySelector('input[name="website"]');
      if (hp && hp.value) return;
      // ciudad obligatoria (buscador custom)
      var cityHidden = form.querySelector('input[name="ciudad"]');
      if (cityHidden && !cityHidden.value) {
        alert('Por favor elegí tu ciudad de la lista.');
        return;
      }

      var formData = new FormData(form);
      var payload = { form_type: cfg.formType, fuente: cfg.fuente, fecha: new Date().toISOString() };
      if (cfg.formType === 'comite') {
        payload.comites_seleccionados = formData.getAll('comite[]');
        formData.forEach(function (v, k) { if (k !== 'comite[]') payload[k] = v; });
      } else {
        formData.forEach(function (v, k) { payload[k] = v; });
      }

      saveBackup(payload);
      var btn = form.querySelector('button[type="submit"]');
      var originalText = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'ENVIANDO…'; }

      submitWithRetry(cfg.webhook, payload, 2).then(function () {
        clearBackup();
        var success = form.parentElement.querySelector('.cleo-form__success');
        form.style.display = 'none';
        if (success) success.classList.add('is-show');
      }).catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = originalText; }
        var waText = encodeURIComponent('Hola CLEO! Quiero postularme (' + cfg.formType + ').\nNombre: ' + (payload.nombre || '') + '\nEmail: ' + (payload.email || ''));
        if (confirm('Hubo un problema al enviar. ¿Abrir WhatsApp con tus datos?')) {
          window.open('https://wa.me/' + WA_NUM + '?text=' + waText, '_blank');
        }
      });
    });

    // reenviar backups pendientes al cargar
    (function () {
      try {
        var arr = JSON.parse(localStorage.getItem(backupKey) || '[]');
        arr.forEach(function (item) {
          if (Date.now() - item.ts > 7 * 24 * 60 * 60 * 1000) return;
          submitWithRetry(cfg.webhook, item.payload, 1).then(function () {}).catch(function () {});
        });
        setTimeout(function () { try { localStorage.removeItem(backupKey); } catch (e) {} }, 5000);
      } catch (e) {}
    })();
  }

  bindBlindajeForm({
    formId: 'cleo-form-mentora',
    formType: 'mentora',
    fuente: 'landing-cleo-mentora',
    webhook: 'https://hook.us2.make.com/vcik31w6pam8ygqenylz3zd6kev6j5ob',
    backupKey: 'cleo_pending_mentora'
  });
  bindBlindajeForm({
    formId: 'cleo-form-comite',
    formType: 'comite',
    fuente: 'landing-cleo-comite',
    webhook: 'https://hook.us2.make.com/i1tezgkkwqfemw9pg57mk4rlq7efpd96',
    backupKey: 'cleo_pending_comite'
  });

  /* ---------- Smooth scroll CTAs internos ----------
     Los CTAs que apuntan a #postular-mentora / #postular-comite SOLO
     hacen scroll hasta la sección Postulate (los 2 botones grandes).
     NO abren el formulario — eso pasa únicamente al tocar un botón. */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (id.length > 1) {
        var dest = id;
        if (id.indexOf('#postular-') === 0) dest = '#postular';
        var t = document.querySelector(dest);
        if (t) {
          e.preventDefault();
          window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 70, behavior: 'smooth' });
        }
      }
    });
  });
})();
